import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { SharedModule } from '@/shared.module';
import { RegistrationState } from '@/models';
import type { NnnRegistrationSimple } from '@/services';

export const NEW_REGISTRATION_VERSION = '-2';

/**
 * Version picker of the careplan-NNN row table. Lists the registrations with
 * their state, (view-)date and (view-)user, plus a "new" option when there is
 * nothing to select yet.
 */
@Component({
  selector: 'app-nnn-registration-version-select',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './nnn-registration-version-select.component.html',
  styleUrl: './nnn-registration-version-select.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NnnRegistrationVersionSelectComponent {
  readonly registrations = input<NnnRegistrationSimple[]>([]);
  readonly selectedId = input.required<string>();
  readonly showNewOption = input(false);

  readonly versionChange = output<string>();

  protected readonly conceptState = RegistrationState.CONCEPT;
  protected readonly newVersion = NEW_REGISTRATION_VERSION;
}
